"use client";
import { Button } from "components/UI/buttons/Button";
import { Heading } from "components/UI/typography/Heading";
import Image from "next/legacy/image";
import { FC, useState } from "react";
import s from "./IdlePopup.module.scss";
import { Modal } from "./Modal";
import checkIcon from "public/img/icons/check-main.svg";
import trophyIcon from "public/img/icons/trophy-secondary.svg";
import supportIcon from "public/img/icons/support.svg";
import { SpriteIcon } from "components/UI/SpriteIcon";
import { baseUrl } from "const";
import { useIdleTime } from "@/utils/useIdleTime";

export const IdlePopup = () => {
  const { timePassed, resetTime } = useIdleTime();
  const [open, setOpen] = useState(true);

  return timePassed ? (
    <Modal open={open} setOpen={setOpen} onClick={resetTime} type="idlePopup">
      <a href={`https://app.${String(baseUrl)}/order`} className={s.wrapper}>
        <Heading level={2} className={s.heading}>
          Need an{" "}
          <span>
            Essay Written <br />
            Specially
          </span>{" "}
          for You?
        </Heading>
        <Image src="/img/idle-popup.svg" alt="Illustration" width={158} height={140} />
        <p className={s.description}>
          Get an expert to write a paper
          <br /> tailored to your needs.
        </p>
        <Button tag="span" type="accent" className={s.button}>
          Order essay
        </Button>
        <div className={s.cols}>
          <div className={s.icon}>
            <SpriteIcon icon={checkIcon} />
            <span>100% Uniqueness</span>
          </div>
          <div className={s.icon}>
            <SpriteIcon icon={trophyIcon} />
            <span>Top Quality</span>
          </div>
          <div className={s.icon}>
            <SpriteIcon icon={supportIcon} />
            <span>24/7 Support</span>
          </div>
        </div>
      </a>
    </Modal>
  ) : null;
};
